module.exports = __webpack_public_path__ + "fonts/Roboto-Bold.8eb2bc10.woff2";